export default __webpack_public_path__ + "static/banner-uiuxcamp2024-433dc827d9ca17d04d0b701c5b8b953d.png";